<section class="p-6 max-w-[890px] mx-auto wysiwyg product-builder-wysiwyg" [innerHTML]=" content"
  [ngClass]="isCenterAligned && 'text-center'">
</section>
